import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { tokenType } from './cst.js';
import { Lexer } from './lexer.js';

function includesToken(list, type) {
  for (var i = 0; i < list.length; ++i) {
    if (list[i].type === type) return true;
  }

  return false;
}

function findNonEmptyIndex(list) {
  for (var i = 0; i < list.length; ++i) {
    switch (list[i].type) {
      case 'space':
      case 'comment':
      case 'newline':
        break;

      default:
        return i;
    }
  }

  return -1;
}

function isFlowToken(token) {
  switch (token === null || token === void 0 ? void 0 : token.type) {
    case 'alias':
    case 'scalar':
    case 'single-quoted-scalar':
    case 'double-quoted-scalar':
    case 'flow-collection':
      return true;

    default:
      return false;
  }
}

function getPrevProps(parent) {
  switch (parent.type) {
    case 'document':
      return parent.start;

    case 'block-map':
      {
        var _it$sep;

        var it = parent.items[parent.items.length - 1];
        return (_it$sep = it.sep) !== null && _it$sep !== void 0 ? _it$sep : it.start;
      }

    case 'block-seq':
      return parent.items[parent.items.length - 1].start;

    /* istanbul ignore next should not happen */

    default:
      return [];
  }
}
/** Note: May modify input array */


function getFirstKeyStartProps(prev) {
  if (prev.length === 0) return [];
  var i = prev.length;

  loop: while (--i >= 0) {
    switch (prev[i].type) {
      case 'doc-start':
      case 'explicit-key-ind':
      case 'map-value-ind':
      case 'seq-item-ind':
      case 'newline':
        break loop;
    }
  }

  while (((_prev$i = prev[++i]) === null || _prev$i === void 0 ? void 0 : _prev$i.type) === 'space') {
    /* loop */

    var _prev$i;
  }

  return prev.splice(i, prev.length);
}

function fixFlowSeqItems(fc) {
  if (fc.start.type === 'flow-seq-start') {
    var _iterator = _createForOfIteratorHelper(fc.items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var it = _step.value;

        if (it.sep && !it.value && !includesToken(it.start, 'explicit-key-ind') && !includesToken(it.sep, 'map-value-ind')) {
          if (it.key) it.value = it.key;
          delete it.key;

          if (isFlowToken(it.value)) {
            if (it.value.end) Array.prototype.push.apply(it.value.end, it.sep);else it.value.end = it.sep;
          } else Array.prototype.push.apply(it.start, it.sep);

          delete it.sep;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}
/**
 * A YAML concrete syntax tree (CST) parser
 *
 * ```ts
 * const src: string = ...
 * for (const token of new Parser().parse(src)) {
 *   // token: Token
 * }
 * ```
 *
 * To use the parser with a user-provided lexer:
 *
 * ```ts
 * function* parse(source: string, lexer: Lexer) {
 *   const parser = new Parser()
 *   for (const lexeme of lexer.lex(source))
 *     yield* parser.next(lexeme)
 *   yield* parser.end()
 * }
 *
 * const src: string = ...
 * const lexer = new Lexer()
 * for (const token of parse(src, lexer)) {
 *   // token: Token
 * }
 * ```
 */


var Parser = /*#__PURE__*/function () {
  /**
   * @param onNewLine - If defined, called separately with the start position of
   *   each new line (in `parse()`, including the start of input).
   */
  function Parser(onNewLine) {
    _classCallCheck(this, Parser);

    /** If true, space and sequence indicators count as indentation */
    this.atNewLine = true;
    /** If true, next token is a scalar value */

    this.atScalar = false;
    /** Current indentation level */

    this.indent = 0;
    /** Current offset since the start of parsing */

    this.offset = 0;
    /** On the same line with a block map key */

    this.onKeyLine = false;
    /** Top indicates the node that's currently being built */

    this.stack = [];
    /** The source of the current token, set in parse() */

    this.source = '';
    /** The type of the current token, set in parse() */

    this.type = ''; // Must be defined after `next()`

    this.lexer = new Lexer();
    this.onNewLine = onNewLine;
  }
  /**
   * Parse `source` as a YAML stream.
   * If `incomplete`, a part of the last line may be left as a buffer for the next call.
   *
   * Errors are not thrown, but yielded as `{ type: 'error', message }` tokens.
   *
   * @returns A generator of tokens representing each directive, document, and other structure.
   */


  _createClass(Parser, [{
    key: "parse",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function parse(source) {
      var incomplete,
          _iterator2,
          _step2,
          lexeme,
          _args = arguments;

      return _regeneratorRuntime.wrap(function parse$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              incomplete = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              if (this.onNewLine && this.offset === 0) this.onNewLine(0);
              _iterator2 = _createForOfIteratorHelper(this.lexer.lex(source, incomplete));
              _context.prev = 3;

              _iterator2.s();

            case 5:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 10;
                break;
              }

              lexeme = _step2.value;
              return _context.delegateYield(this.next(lexeme), "t0", 8);

            case 8:
              _context.next = 5;
              break;

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t1 = _context["catch"](3);

              _iterator2.e(_context.t1);

            case 15:
              _context.prev = 15;

              _iterator2.f();

              return _context.finish(15);

            case 18:
              if (incomplete) {
                _context.next = 20;
                break;
              }

              return _context.delegateYield(this.end(), "t2", 20);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, parse, this, [[3, 12, 15, 18]]);
    })
    /**
     * Advance the parser by the `source` of one lexical token.
     */

  }, {
    key: "next",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function next(source) {
      var type, message;
      return _regeneratorRuntime.wrap(function next$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.source = source;

              if (!this.atScalar) {
                _context2.next = 6;
                break;
              }

              this.atScalar = false;
              return _context2.delegateYield(this.step(), "t0", 4);

            case 4:
              this.offset += source.length;
              return _context2.abrupt("return");

            case 6:
              type = tokenType(source);

              if (type) {
                _context2.next = 13;
                break;
              }

              message = "Not a YAML token: ".concat(source);
              return _context2.delegateYield(this.pop({
                type: 'error',
                offset: this.offset,
                message: message,
                source: source
              }), "t1", 10);

            case 10:
              this.offset += source.length;
              _context2.next = 35;
              break;

            case 13:
              if (!(type === 'scalar')) {
                _context2.next = 19;
                break;
              }

              this.atNewLine = false;
              this.atScalar = true;
              this.type = 'scalar';
              _context2.next = 35;
              break;

            case 19:
              this.type = type;
              return _context2.delegateYield(this.step(), "t2", 21);

            case 21:
              _context2.t3 = type;
              _context2.next = _context2.t3 === 'newline' ? 24 : _context2.t3 === 'space' ? 28 : _context2.t3 === 'explicit-key-ind' ? 30 : _context2.t3 === 'map-value-ind' ? 30 : _context2.t3 === 'seq-item-ind' ? 30 : _context2.t3 === 'doc-mode' ? 32 : _context2.t3 === 'flow-error-end' ? 32 : 33;
              break;

            case 24:
              this.atNewLine = true;
              this.indent = 0;
              if (this.onNewLine) this.onNewLine(this.offset + source.length);
              return _context2.abrupt("break", 34);

            case 28:
              if (this.atNewLine && source[0] === ' ') this.indent += source.length;
              return _context2.abrupt("break", 34);

            case 30:
              if (this.atNewLine) this.indent += source.length;
              return _context2.abrupt("break", 34);

            case 32:
              return _context2.abrupt("return");

            case 33:
              this.atNewLine = false;

            case 34:
              this.offset += source.length;

            case 35:
            case "end":
              return _context2.stop();
          }
        }
      }, next, this);
    })
    /** Call at end of input to push out any remaining constructions */

  }, {
    key: "end",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function end() {
      return _regeneratorRuntime.wrap(function end$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.stack.length > 0)) {
                _context3.next = 4;
                break;
              }

              return _context3.delegateYield(this.pop(), "t0", 2);

            case 2:
              _context3.next = 0;
              break;

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, end, this);
    })
  }, {
    key: "sourceToken",
    get: function get() {
      var st = {
        type: this.type,
        offset: this.offset,
        indent: this.indent,
        source: this.source
      };
      return st;
    }
  }, {
    key: "step",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function step() {
      var top;
      return _regeneratorRuntime.wrap(function step$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              top = this.peek(1);

              if (!(this.type === 'doc-end' && (!top || top.type !== 'doc-end'))) {
                _context4.next = 8;
                break;
              }

            case 2:
              if (!(this.stack.length > 0)) {
                _context4.next = 6;
                break;
              }

              return _context4.delegateYield(this.pop(), "t0", 4);

            case 4:
              _context4.next = 2;
              break;

            case 6:
              this.stack.push({
                type: 'doc-end',
                offset: this.offset,
                source: this.source
              });
              return _context4.abrupt("return");

            case 8:
              if (top) {
                _context4.next = 11;
                break;
              }

              return _context4.delegateYield(this.stream(), "t1", 10);

            case 10:
              return _context4.abrupt("return", _context4.t1);

            case 11:
              _context4.t2 = top.type;
              _context4.next = _context4.t2 === 'document' ? 14 : _context4.t2 === 'alias' ? 16 : _context4.t2 === 'scalar' ? 16 : _context4.t2 === 'single-quoted-scalar' ? 16 : _context4.t2 === 'double-quoted-scalar' ? 16 : _context4.t2 === 'block-scalar' ? 18 : _context4.t2 === 'block-map' ? 20 : _context4.t2 === 'block-seq' ? 22 : _context4.t2 === 'flow-collection' ? 24 : _context4.t2 === 'doc-end' ? 26 : 28;
              break;

            case 14:
              return _context4.delegateYield(this.document(top), "t3", 15);

            case 15:
              return _context4.abrupt("return", _context4.t3);

            case 16:
              return _context4.delegateYield(this.scalar(top), "t4", 17);

            case 17:
              return _context4.abrupt("return", _context4.t4);

            case 18:
              return _context4.delegateYield(this.blockScalar(top), "t5", 19);

            case 19:
              return _context4.abrupt("return", _context4.t5);

            case 20:
              return _context4.delegateYield(this.blockMap(top), "t6", 21);

            case 21:
              return _context4.abrupt("return", _context4.t6);

            case 22:
              return _context4.delegateYield(this.blockSequence(top), "t7", 23);

            case 23:
              return _context4.abrupt("return", _context4.t7);

            case 24:
              return _context4.delegateYield(this.flowCollection(top), "t8", 25);

            case 25:
              return _context4.abrupt("return", _context4.t8);

            case 26:
              return _context4.delegateYield(this.documentEnd(top), "t9", 27);

            case 27:
              return _context4.abrupt("return", _context4.t9);

            case 28:
              return _context4.delegateYield(this.pop(), "t10", 29);

            case 29:
            case "end":
              return _context4.stop();
          }
        }
      }, step, this);
    })
  }, {
    key: "peek",
    value: function peek(n) {
      return this.stack[this.stack.length - n];
    }
  }, {
    key: "pop",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function pop(error) {
      var token, message, top, it, _it, _it2, last;

      return _regeneratorRuntime.wrap(function pop$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              token = error !== null && error !== void 0 ? error : this.stack.pop();
              /* istanbul ignore if should not happen */

              if (token) {
                _context5.next = 7;
                break;
              }

              message = 'Tried to pop an empty stack';
              _context5.next = 5;
              return {
                type: 'error',
                offset: this.offset,
                source: '',
                message: message
              };

            case 5:
              _context5.next = 46;
              break;

            case 7:
              if (!(this.stack.length === 0)) {
                _context5.next = 12;
                break;
              }

              _context5.next = 10;
              return token;

            case 10:
              _context5.next = 46;
              break;

            case 12:
              top = this.peek(1);

              if (token.type === 'block-scalar') {
                // Block scalars use their parent rather than header indent
                token.indent = 'indent' in top ? top.indent : 0;
              } else if (token.type === 'flow-collection' && top.type === 'document') {
                // Ignore all indent for top-level flow collections
                token.indent = 0;
              }

              if (token.type === 'flow-collection') fixFlowSeqItems(token);
              _context5.t0 = top.type;
              _context5.next = _context5.t0 === 'document' ? 18 : _context5.t0 === 'block-scalar' ? 20 : _context5.t0 === 'block-map' ? 22 : _context5.t0 === 'block-seq' ? 37 : _context5.t0 === 'flow-collection' ? 40 : 43;
              break;

            case 18:
              top.value = token;
              return _context5.abrupt("break", 45);

            case 20:
              top.props.push(token); // error

              return _context5.abrupt("break", 45);

            case 22:
              it = top.items[top.items.length - 1];

              if (!it.value) {
                _context5.next = 29;
                break;
              }

              top.items.push({
                start: [],
                key: token,
                sep: []
              });
              this.onKeyLine = true;
              return _context5.abrupt("return");

            case 29:
              if (!it.sep) {
                _context5.next = 33;
                break;
              }

              it.value = token;
              _context5.next = 36;
              break;

            case 33:
              Object.assign(it, {
                key: token,
                sep: []
              });
              this.onKeyLine = !it.explicitKey;
              return _context5.abrupt("return");

            case 36:
              return _context5.abrupt("break", 45);

            case 37:
              _it = top.items[top.items.length - 1];
              if (_it.value) top.items.push({
                start: [],
                value: token
              });else _it.value = token;
              return _context5.abrupt("break", 45);

            case 40:
              _it2 = top.items[top.items.length - 1];
              if (!_it2 || _it2.value) top.items.push({
                start: [],
                key: token,
                sep: []
              });else if (_it2.sep) _it2.value = token;else Object.assign(_it2, {
                key: token,
                sep: []
              });
              return _context5.abrupt("return");

            case 43:
              return _context5.delegateYield(this.pop(), "t1", 44);

            case 44:
              return _context5.delegateYield(this.pop(token), "t2", 45);

            case 45:
              if ((top.type === 'document' || top.type === 'block-map' || top.type === 'block-seq') && (token.type === 'block-map' || token.type === 'block-seq')) {
                last = token.items[token.items.length - 1];

                if (last && !last.sep && !last.value && last.start.length > 0 && findNonEmptyIndex(last.start) === -1 && (token.indent === 0 || last.start.every(function (st) {
                  return st.type !== 'comment' || st.indent < token.indent;
                }))) {
                  if (top.type === 'document') top.end = last.start;else top.items.push({
                    start: last.start
                  });
                  token.items.splice(-1, 1);
                }
              }

            case 46:
            case "end":
              return _context5.stop();
          }
        }
      }, pop, this);
    })
  }, {
    key: "stream",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function stream() {
      var doc;
      return _regeneratorRuntime.wrap(function stream$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.t0 = this.type;
              _context6.next = _context6.t0 === 'directive-line' ? 3 : _context6.t0 === 'byte-order-mark' ? 6 : _context6.t0 === 'space' ? 6 : _context6.t0 === 'comment' ? 6 : _context6.t0 === 'newline' ? 6 : _context6.t0 === 'doc-mode' ? 9 : _context6.t0 === 'doc-start' ? 9 : 13;
              break;

            case 3:
              _context6.next = 5;
              return {
                type: 'directive',
                offset: this.offset,
                source: this.source
              };

            case 5:
              return _context6.abrupt("return");

            case 6:
              _context6.next = 8;
              return this.sourceToken;

            case 8:
              return _context6.abrupt("return");

            case 9:
              doc = {
                type: 'document',
                offset: this.offset,
                start: []
              };
              if (this.type === 'doc-start') doc.start.push(this.sourceToken);
              this.stack.push(doc);
              return _context6.abrupt("return");

            case 13:
              _context6.next = 15;
              return {
                type: 'error',
                offset: this.offset,
                message: "Unexpected ".concat(this.type, " token in YAML stream"),
                source: this.source
              };

            case 15:
            case "end":
              return _context6.stop();
          }
        }
      }, stream, this);
    })
  }, {
    key: "document",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function document(doc) {
      var bv;
      return _regeneratorRuntime.wrap(function document$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (!doc.value) {
                _context7.next = 3;
                break;
              }

              return _context7.delegateYield(this.lineEnd(doc), "t0", 2);

            case 2:
              return _context7.abrupt("return", _context7.t0);

            case 3:
              _context7.t1 = this.type;
              _context7.next = _context7.t1 === 'doc-start' ? 6 : _context7.t1 === 'anchor' ? 13 : _context7.t1 === 'tag' ? 13 : _context7.t1 === 'space' ? 13 : _context7.t1 === 'comment' ? 13 : _context7.t1 === 'newline' ? 13 : 15;
              break;

            case 6:
              if (!(findNonEmptyIndex(doc.start) !== -1)) {
                _context7.next = 11;
                break;
              }

              return _context7.delegateYield(this.pop(), "t2", 8);

            case 8:
              return _context7.delegateYield(this.step(), "t3", 9);

            case 9:
              _context7.next = 12;
              break;

            case 11:
              doc.start.push(this.sourceToken);

            case 12:
              return _context7.abrupt("return");

            case 13:
              doc.start.push(this.sourceToken);
              return _context7.abrupt("return");

            case 15:
              bv = this.startBlockValue(doc);

              if (!bv) {
                _context7.next = 20;
                break;
              }

              this.stack.push(bv);
              _context7.next = 22;
              break;

            case 20:
              _context7.next = 22;
              return {
                type: 'error',
                offset: this.offset,
                message: "Unexpected ".concat(this.type, " token in YAML document"),
                source: this.source
              };

            case 22:
            case "end":
              return _context7.stop();
          }
        }
      }, document, this);
    })
  }, {
    key: "scalar",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function scalar(_scalar) {
      var prev, start, sep, map;
      return _regeneratorRuntime.wrap(function scalar$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!(this.type === 'map-value-ind')) {
                _context8.next = 9;
                break;
              }

              prev = getPrevProps(this.peek(2));
              start = getFirstKeyStartProps(prev);

              if (_scalar.end) {
                sep = _scalar.end;
                sep.push(this.sourceToken);
                delete _scalar.end;
              } else sep = [this.sourceToken];

              map = {
                type: 'block-map',
                offset: _scalar.offset,
                indent: _scalar.indent,
                items: [{
                  start: start,
                  key: _scalar,
                  sep: sep
                }]
              };
              this.onKeyLine = true;
              this.stack[this.stack.length - 1] = map;
              _context8.next = 10;
              break;

            case 9:
              return _context8.delegateYield(this.lineEnd(_scalar), "t0", 10);

            case 10:
            case "end":
              return _context8.stop();
          }
        }
      }, scalar, this);
    })
  }, {
    key: "blockScalar",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function blockScalar(scalar) {
      var nl;
      return _regeneratorRuntime.wrap(function blockScalar$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.t0 = this.type;
              _context9.next = _context9.t0 === 'space' ? 3 : _context9.t0 === 'comment' ? 3 : _context9.t0 === 'newline' ? 3 : _context9.t0 === 'scalar' ? 5 : 11;
              break;

            case 3:
              scalar.props.push(this.sourceToken);
              return _context9.abrupt("return");

            case 5:
              scalar.source = this.source; // block-scalar source includes trailing newline

              this.atNewLine = true;
              this.indent = 0;

              if (this.onNewLine) {
                nl = this.source.indexOf('\n') + 1;

                while (nl !== 0) {
                  this.onNewLine(this.offset + nl);
                  nl = this.source.indexOf('\n', nl) + 1;
                }
              }

              return _context9.delegateYield(this.pop(), "t1", 10);

            case 10:
              return _context9.abrupt("break", 13);

            case 11:
              return _context9.delegateYield(this.pop(), "t2", 12);

            case 12:
              return _context9.delegateYield(this.step(), "t3", 13);

            case 13:
            case "end":
              return _context9.stop();
          }
        }
      }, blockScalar, this);
    })
  }, {
    key: "blockMap",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function blockMap(map) {
      var it, _end, last, _prev$value, prev, _end2, atMapIndent, atNextItem, start, nl, i, st, _start, _start2, key, sep, fs, bv;

      return _regeneratorRuntime.wrap(function blockMap$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              it = map.items[map.items.length - 1]; // it.sep is true-ish if pair already has key or : separator

              _context10.t0 = this.type;
              _context10.next = _context10.t0 === 'newline' ? 4 : _context10.t0 === 'space' ? 7 : _context10.t0 === 'comment' ? 7 : 25;
              break;

            case 4:
              this.onKeyLine = false;

              if (it.value) {
                _end = 'end' in it.value ? it.value.end : undefined;
                last = Array.isArray(_end) ? _end[_end.length - 1] : undefined;
                if ((last === null || last === void 0 ? void 0 : last.type) === 'comment') _end === null || _end === void 0 ? void 0 : _end.push(this.sourceToken);else map.items.push({
                  start: [this.sourceToken]
                });
              } else if (it.sep) {
                it.sep.push(this.sourceToken);
              } else {
                it.start.push(this.sourceToken);
              }

              return _context10.abrupt("return");

            case 7:
              if (!it.value) {
                _context10.next = 11;
                break;
              }

              map.items.push({
                start: [this.sourceToken]
              });
              _context10.next = 24;
              break;

            case 11:
              if (!it.sep) {
                _context10.next = 15;
                break;
              }

              it.sep.push(this.sourceToken);
              _context10.next = 24;
              break;

            case 15:
              if (!this.atIndentedComment(it.start, map.indent)) {
                _context10.next = 23;
                break;
              }

              prev = map.items[map.items.length - 2];
              _end2 = prev === null || prev === void 0 ? void 0 : (_prev$value = prev.value) === null || _prev$value === void 0 ? void 0 : _prev$value.end;

              if (!Array.isArray(_end2)) {
                _context10.next = 23;
                break;
              }

              Array.prototype.push.apply(_end2, it.start);

              _end2.push(this.sourceToken);

              map.items.pop();
              return _context10.abrupt("return");

            case 23:
              it.start.push(this.sourceToken);

            case 24:
              return _context10.abrupt("return");

            case 25:
              if (!(this.indent >= map.indent)) {
                _context10.next = 66;
                break;
              }

              atMapIndent = !this.onKeyLine && this.indent === map.indent;
              atNextItem = atMapIndent && (it.sep || it.explicitKey) && this.type !== 'seq-item-ind'; // For empty nodes, assign newline-separated not indented empty tokens to following node

              start = [];

              if (!(atNextItem && it.sep && !it.value)) {
                _context10.next = 47;
                break;
              }

              nl = [];
              i = 0;

            case 32:
              if (!(i < it.sep.length)) {
                _context10.next = 46;
                break;
              }

              st = it.sep[i];
              _context10.t1 = st.type;
              _context10.next = _context10.t1 === 'newline' ? 37 : _context10.t1 === 'space' ? 39 : _context10.t1 === 'comment' ? 40 : 42;
              break;

            case 37:
              nl.push(i);
              return _context10.abrupt("break", 43);

            case 39:
              return _context10.abrupt("break", 43);

            case 40:
              if (st.indent > map.indent) nl.length = 0;
              return _context10.abrupt("break", 43);

            case 42:
              nl.length = 0;

            case 43:
              ++i;
              _context10.next = 32;
              break;

            case 46:
              if (nl.length >= 2) start = it.sep.splice(nl[1]);

            case 47:
              _context10.t2 = this.type;
              _context10.next = _context10.t2 === 'anchor' ? 50 : _context10.t2 === 'tag' ? 50 : _context10.t2 === 'explicit-key-ind' ? 52 : _context10.t2 === 'map-value-ind' ? 55 : _context10.t2 === 'alias' ? 58 : _context10.t2 === 'scalar' ? 58 : _context10.t2 === 'single-quoted-scalar' ? 58 : _context10.t2 === 'double-quoted-scalar' ? 58 : 61;
              break;

            case 50:
              if (atNextItem || it.value) {
                start.push(this.sourceToken);
                map.items.push({
                  start: start
                });
                this.onKeyLine = true;
              } else if (it.sep) {
                it.sep.push(this.sourceToken);
              } else {
                it.start.push(this.sourceToken);
              }

              return _context10.abrupt("return");

            case 52:
              if (!it.sep && !it.explicitKey) {
                it.start.push(this.sourceToken);
                it.explicitKey = true;
              } else if (atNextItem || it.value) {
                start.push(this.sourceToken);
                map.items.push({
                  start: start,
                  explicitKey: true
                });
              } else {
                this.stack.push({
                  type: 'block-map',
                  offset: this.offset,
                  indent: this.indent,
                  items: [{
                    start: [this.sourceToken],
                    explicitKey: true
                  }]
                });
              }

              this.onKeyLine = true;
              return _context10.abrupt("return");

            case 55:
              if (it.explicitKey) {
                if (!it.sep) {
                  if (includesToken(it.start, 'newline')) {
                    Object.assign(it, {
                      key: null,
                      sep: [this.sourceToken]
                    });
                  } else {
                    _start = getFirstKeyStartProps(it.start);
                    this.stack.push({
                      type: 'block-map',
                      offset: this.offset,
                      indent: this.indent,
                      items: [{
                        start: _start,
                        key: null,
                        sep: [this.sourceToken]
                      }]
                    });
                  }
                } else if (it.value) {
                  map.items.push({
                    start: [],
                    key: null,
                    sep: [this.sourceToken]
                  });
                } else if (includesToken(it.sep, 'map-value-ind')) {
                  this.stack.push({
                    type: 'block-map',
                    offset: this.offset,
                    indent: this.indent,
                    items: [{
                      start: start,
                      key: null,
                      sep: [this.sourceToken]
                    }]
                  });
                } else if (isFlowToken(it.key) && !includesToken(it.sep, 'newline')) {
                  _start2 = getFirstKeyStartProps(it.start);
                  key = it.key;
                  sep = it.sep;
                  sep.push(this.sourceToken); // @ts-expect-error type guard is wrong here

                  delete it.key; // @ts-expect-error type guard is wrong here

                  delete it.sep;
                  this.stack.push({
                    type: 'block-map',
                    offset: this.offset,
                    indent: this.indent,
                    items: [{
                      start: _start2,
                      key: key,
                      sep: sep
                    }]
                  });
                } else if (start.length > 0) {
                  // Not actually at next item
                  it.sep = it.sep.concat(start, this.sourceToken);
                } else {
                  it.sep.push(this.sourceToken);
                }
              } else {
                if (!it.sep) {
                  Object.assign(it, {
                    key: null,
                    sep: [this.sourceToken]
                  });
                } else if (it.value || atNextItem) {
                  map.items.push({
                    start: start,
                    key: null,
                    sep: [this.sourceToken]
                  });
                } else if (includesToken(it.sep, 'map-value-ind')) {
                  this.stack.push({
                    type: 'block-map',
                    offset: this.offset,
                    indent: this.indent,
                    items: [{
                      start: [],
                      key: null,
                      sep: [this.sourceToken]
                    }]
                  });
                } else {
                  it.sep.push(this.sourceToken);
                }
              }

              this.onKeyLine = true;
              return _context10.abrupt("return");

            case 58:
              fs = this.flowScalar(this.type);

              if (atNextItem || it.value) {
                map.items.push({
                  start: start,
                  key: fs,
                  sep: []
                });
                this.onKeyLine = true;
              } else if (it.sep) {
                this.stack.push(fs);
              } else {
                Object.assign(it, {
                  key: fs,
                  sep: []
                });
                this.onKeyLine = true;
              }

              return _context10.abrupt("return");

            case 61:
              bv = this.startBlockValue(map);

              if (!bv) {
                _context10.next = 66;
                break;
              }

              if (atMapIndent && bv.type !== 'block-seq') {
                map.items.push({
                  start: start
                });
              }

              this.stack.push(bv);
              return _context10.abrupt("return");

            case 66:
              return _context10.delegateYield(this.pop(), "t3", 67);

            case 67:
              return _context10.delegateYield(this.step(), "t4", 68);

            case 68:
            case "end":
              return _context10.stop();
          }
        }
      }, blockMap, this);
    })
  }, {
    key: "blockSequence",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function blockSequence(seq) {
      var it, _end3, last, _prev$value2, prev, _end4, bv;

      return _regeneratorRuntime.wrap(function blockSequence$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              it = seq.items[seq.items.length - 1];
              _context11.t0 = this.type;
              _context11.next = _context11.t0 === 'newline' ? 4 : _context11.t0 === 'space' ? 6 : _context11.t0 === 'comment' ? 6 : _context11.t0 === 'anchor' ? 20 : _context11.t0 === 'tag' ? 20 : _context11.t0 === 'seq-item-ind' ? 24 : 28;
              break;

            case 4:
              if (it.value) {
                _end3 = 'end' in it.value ? it.value.end : undefined;
                last = Array.isArray(_end3) ? _end3[_end3.length - 1] : undefined;
                if ((last === null || last === void 0 ? void 0 : last.type) === 'comment') _end3 === null || _end3 === void 0 ? void 0 : _end3.push(this.sourceToken);else seq.items.push({
                  start: [this.sourceToken]
                });
              } else it.start.push(this.sourceToken);

              return _context11.abrupt("return");

            case 6:
              if (!it.value) {
                _context11.next = 10;
                break;
              }

              seq.items.push({
                start: [this.sourceToken]
              });
              _context11.next = 19;
              break;

            case 10:
              if (!this.atIndentedComment(it.start, seq.indent)) {
                _context11.next = 18;
                break;
              }

              prev = seq.items[seq.items.length - 2];
              _end4 = prev === null || prev === void 0 ? void 0 : (_prev$value2 = prev.value) === null || _prev$value2 === void 0 ? void 0 : _prev$value2.end;

              if (!Array.isArray(_end4)) {
                _context11.next = 18;
                break;
              }

              Array.prototype.push.apply(_end4, it.start);

              _end4.push(this.sourceToken);

              seq.items.pop();
              return _context11.abrupt("return");

            case 18:
              it.start.push(this.sourceToken);

            case 19:
              return _context11.abrupt("return");

            case 20:
              if (!(it.value || this.indent <= seq.indent)) {
                _context11.next = 22;
                break;
              }

              return _context11.abrupt("break", 28);

            case 22:
              it.start.push(this.sourceToken);
              return _context11.abrupt("return");

            case 24:
              if (!(this.indent !== seq.indent)) {
                _context11.next = 26;
                break;
              }

              return _context11.abrupt("break", 28);

            case 26:
              if (it.value || includesToken(it.start, 'seq-item-ind')) seq.items.push({
                start: [this.sourceToken]
              });else it.start.push(this.sourceToken);
              return _context11.abrupt("return");

            case 28:
              if (!(this.indent > seq.indent)) {
                _context11.next = 33;
                break;
              }

              bv = this.startBlockValue(seq);

              if (!bv) {
                _context11.next = 33;
                break;
              }

              this.stack.push(bv);
              return _context11.abrupt("return");

            case 33:
              return _context11.delegateYield(this.pop(), "t1", 34);

            case 34:
              return _context11.delegateYield(this.step(), "t2", 35);

            case 35:
            case "end":
              return _context11.stop();
          }
        }
      }, blockSequence, this);
    })
  }, {
    key: "flowCollection",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function flowCollection(fc) {
      var it, top, fs, bv, parent, prev, start, sep, map;
      return _regeneratorRuntime.wrap(function flowCollection$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              it = fc.items[fc.items.length - 1];

              if (!(this.type === 'flow-error-end')) {
                _context12.next = 7;
                break;
              }

            case 2:
              return _context12.delegateYield(this.pop(), "t0", 3);

            case 3:
              top = this.peek(1);

            case 4:
              if (top && top.type === 'flow-collection') {
                _context12.next = 2;
                break;
              }

            case 5:
              _context12.next = 49;
              break;

            case 7:
              if (!(fc.end.length === 0)) {
                _context12.next = 31;
                break;
              }

              _context12.t1 = this.type;
              _context12.next = _context12.t1 === 'comma' ? 11 : _context12.t1 === 'explicit-key-ind' ? 11 : _context12.t1 === 'map-value-ind' ? 13 : _context12.t1 === 'space' ? 15 : _context12.t1 === 'comment' ? 15 : _context12.t1 === 'newline' ? 15 : _context12.t1 === 'anchor' ? 15 : _context12.t1 === 'tag' ? 15 : _context12.t1 === 'alias' ? 17 : _context12.t1 === 'scalar' ? 17 : _context12.t1 === 'single-quoted-scalar' ? 17 : _context12.t1 === 'double-quoted-scalar' ? 17 : _context12.t1 === 'flow-map-end' ? 20 : _context12.t1 === 'flow-seq-end' ? 20 : 22;
              break;

            case 11:
              if (!it || it.sep) fc.items.push({
                start: [this.sourceToken]
              });else it.start.push(this.sourceToken);
              return _context12.abrupt("return");

            case 13:
              if (!it || it.value) fc.items.push({
                start: [],
                key: null,
                sep: [this.sourceToken]
              });else if (it.sep) it.sep.push(this.sourceToken);else Object.assign(it, {
                key: null,
                sep: [this.sourceToken]
              });
              return _context12.abrupt("return");

            case 15:
              if (!it || it.value) fc.items.push({
                start: [this.sourceToken]
              });else if (it.sep) it.sep.push(this.sourceToken);else it.start.push(this.sourceToken);
              return _context12.abrupt("return");

            case 17:
              fs = this.flowScalar(this.type);
              if (!it || it.value) fc.items.push({
                start: [],
                key: fs,
                sep: []
              });else if (it.sep) this.stack.push(fs);else Object.assign(it, {
                key: fs,
                sep: []
              });
              return _context12.abrupt("return");

            case 20:
              fc.end.push(this.sourceToken);
              return _context12.abrupt("return");

            case 22:
              bv = this.startBlockValue(fc);
              /* istanbul ignore else should not happen */

              if (!bv) {
                _context12.next = 27;
                break;
              }

              this.stack.push(bv);
              _context12.next = 29;
              break;

            case 27:
              return _context12.delegateYield(this.pop(), "t2", 28);

            case 28:
              return _context12.delegateYield(this.step(), "t3", 29);

            case 29:
              _context12.next = 49;
              break;

            case 31:
              parent = this.peek(2);

              if (!(parent.type === 'block-map' && (this.type === 'map-value-ind' && parent.indent === fc.indent || this.type === 'newline' && !parent.items[parent.items.length - 1].sep))) {
                _context12.next = 37;
                break;
              }

              return _context12.delegateYield(this.pop(), "t4", 34);

            case 34:
              return _context12.delegateYield(this.step(), "t5", 35);

            case 35:
              _context12.next = 49;
              break;

            case 37:
              if (!(this.type === 'map-value-ind' && parent.type !== 'flow-collection')) {
                _context12.next = 48;
                break;
              }

              prev = getPrevProps(parent);
              start = getFirstKeyStartProps(prev);
              fixFlowSeqItems(fc);
              sep = fc.end.splice(1, fc.end.length);
              sep.push(this.sourceToken);
              map = {
                type: 'block-map',
                offset: fc.offset,
                indent: fc.indent,
                items: [{
                  start: start,
                  key: fc,
                  sep: sep
                }]
              };
              this.onKeyLine = true;
              this.stack[this.stack.length - 1] = map;
              _context12.next = 49;
              break;

            case 48:
              return _context12.delegateYield(this.lineEnd(fc), "t6", 49);

            case 49:
            case "end":
              return _context12.stop();
          }
        }
      }, flowCollection, this);
    })
  }, {
    key: "flowScalar",
    value: function flowScalar(type) {
      if (this.onNewLine) {
        var nl = this.source.indexOf('\n') + 1;

        while (nl !== 0) {
          this.onNewLine(this.offset + nl);
          nl = this.source.indexOf('\n', nl) + 1;
        }
      }

      return {
        type: type,
        offset: this.offset,
        indent: this.indent,
        source: this.source
      };
    }
  }, {
    key: "startBlockValue",
    value: function startBlockValue(parent) {
      switch (this.type) {
        case 'alias':
        case 'scalar':
        case 'single-quoted-scalar':
        case 'double-quoted-scalar':
          return this.flowScalar(this.type);

        case 'block-scalar-header':
          return {
            type: 'block-scalar',
            offset: this.offset,
            indent: this.indent,
            props: [this.sourceToken],
            source: ''
          };

        case 'flow-map-start':
        case 'flow-seq-start':
          return {
            type: 'flow-collection',
            offset: this.offset,
            indent: this.indent,
            start: this.sourceToken,
            items: [],
            end: []
          };

        case 'seq-item-ind':
          return {
            type: 'block-seq',
            offset: this.offset,
            indent: this.indent,
            items: [{
              start: [this.sourceToken]
            }]
          };

        case 'explicit-key-ind':
          {
            this.onKeyLine = true;
            var prev = getPrevProps(parent);
            var start = getFirstKeyStartProps(prev);
            start.push(this.sourceToken);
            return {
              type: 'block-map',
              offset: this.offset,
              indent: this.indent,
              items: [{
                start: start,
                explicitKey: true
              }]
            };
          }

        case 'map-value-ind':
          {
            this.onKeyLine = true;

            var _prev = getPrevProps(parent);

            var _start3 = getFirstKeyStartProps(_prev);

            return {
              type: 'block-map',
              offset: this.offset,
              indent: this.indent,
              items: [{
                start: _start3,
                key: null,
                sep: [this.sourceToken]
              }]
            };
          }
      }

      return null;
    }
  }, {
    key: "atIndentedComment",
    value: function atIndentedComment(start, indent) {
      if (this.type !== 'comment') return false;
      if (this.indent <= indent) return false;
      return start.every(function (st) {
        return st.type === 'newline' || st.type === 'space';
      });
    }
  }, {
    key: "documentEnd",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function documentEnd(docEnd) {
      return _regeneratorRuntime.wrap(function documentEnd$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (!(this.type !== 'doc-mode')) {
                _context13.next = 4;
                break;
              }

              if (docEnd.end) docEnd.end.push(this.sourceToken);else docEnd.end = [this.sourceToken];

              if (!(this.type === 'newline')) {
                _context13.next = 4;
                break;
              }

              return _context13.delegateYield(this.pop(), "t0", 4);

            case 4:
            case "end":
              return _context13.stop();
          }
        }
      }, documentEnd, this);
    })
  }, {
    key: "lineEnd",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function lineEnd(token) {
      return _regeneratorRuntime.wrap(function lineEnd$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.t0 = this.type;
              _context14.next = _context14.t0 === 'comma' ? 3 : _context14.t0 === 'doc-start' ? 3 : _context14.t0 === 'doc-end' ? 3 : _context14.t0 === 'flow-seq-end' ? 3 : _context14.t0 === 'flow-map-end' ? 3 : _context14.t0 === 'map-value-ind' ? 3 : _context14.t0 === 'newline' ? 6 : _context14.t0 === 'space' ? 7 : _context14.t0 === 'comment' ? 7 : 7;
              break;

            case 3:
              return _context14.delegateYield(this.pop(), "t1", 4);

            case 4:
              return _context14.delegateYield(this.step(), "t2", 5);

            case 5:
              return _context14.abrupt("break", 10);

            case 6:
              this.onKeyLine = false;

            case 7:
              // all other values are errors
              if (token.end) token.end.push(this.sourceToken);else token.end = [this.sourceToken];

              if (!(this.type === 'newline')) {
                _context14.next = 10;
                break;
              }

              return _context14.delegateYield(this.pop(), "t3", 10);

            case 10:
            case "end":
              return _context14.stop();
          }
        }
      }, lineEnd, this);
    })
  }]);

  return Parser;
}();

export { Parser };